import * as Actions from '../../actions/user'

const initialState = {
  data: [],
  selected: {
    data: {},
    isLoading: false,
    error: false
  },
  isLoading: false,
  isLoaded: false,
  error: false
}

const users = function (state = initialState, action) {
  switch (action.type) {
    case Actions.GET_USERS: {
      return {
        ...state,
        isLoading: true,
        isLoaded: false,
        error: false
      }
    }
    case Actions.GET_USERS_SUCCESS: {
      return {
        ...state,
        data: action.payload,
        isLoading: false,
        isLoaded: true,
        error: false
      }
    }
    case Actions.GET_USERS_ERROR: {
      return {
        ...state,
        isLoading: false,
        isLoaded: false,
        error: action.error
      }
    }

    case Actions.SET_SELECTED_USER: case Actions.UPDATE_USER: case Actions.CHANGE_USER_EMAIL: case Actions.SET_VALID_PHONE: {
      return {
        ...state,
        selected: {
          ...state.selected,
          isLoading: true
        }
      }
    }
    case Actions.SET_SELECTED_USER_SUCCESS: case Actions.UPDATE_USER_SUCCESS: case Actions.CHANGE_USER_EMAIL_SUCCESS: case Actions.SET_VALID_PHONE_SUCCESS: {
      return {
        ...state,
        selected: {
          data: action.payload,
          isLoading: false,
          error: false
        }
      }
    }
    case Actions.SET_SELECTED_USER_ERROR: case Actions.UPDATE_USER_ERROR: case Actions.CHANGE_USER_EMAIL_ERROR: case Actions.SET_VALID_PHONE_ERROR: {
      return {
        ...state,
        selected: {
          ...state.selected,
          isLoading: false,
          error: action.error
        }
      }
    }
    case Actions.DELETE_USER: {
      return {
        ...state,
        selected: {
          ...state.selected,
          isLoading: true
        },
        isLoading: true,
        isLoaded: false,
        error: false
      }
    }
    case Actions.DELETE_USER_SUCCESS: {
      return {
        ...state,
        data: state.data.filter(u => u.firebaseUid !== action.payload),
        selected: {
          ...state.selected,
          data: {},
          isLoading: false,
          error: false
        },
        isLoading: false,
        isLoaded: true,
        error: false
      }
    }
    case Actions.DELETE_USER_ERROR: {
      return {
        ...state,
        selected: {
          ...state.selected,
          isLoading: false,
          error: action.error
        },
        isLoading: false,
        isLoaded: false,
        error: action.error
      }
    }

    default: {
      return state
    }
  }
}

export default users
